import { useMemo } from "react";

export function usePayeeHistoryResources(payeeId: string) {
  return useMemo(
    () => [
      {
        resourceType: "Payee",
        resourceId: payeeId
      }
    ],
    [payeeId]
  );
}
